import '../../../js/core.js'
import 'sticky-kit/dist/sticky-kit'
import '../../../js/scroll-to-anchor.js'
import '../../../js/bottom-banner.js'
import '../../../js/sticky-sidebar.js'
import '../../../js/progress-bar.js'
import '../../../js/switcher.js'
import '../../../js/contact-form.js'
import './default-template.less';

(function(){
  var url = window.location.href;

  $(".link-single a").each(function() {
      if(url == (this.href)) {
          $(this).closest("li").addClass("active");
      }
  });
})()

$(function () {
  import(/* webpackChunkName: "chunk.owl-carousel" */ 'owl.carousel/src/js/owl.carousel').then(()=>{
    import(/* webpackChunkName: "chunk.owl-carousel-navigation" */ 'owl.carousel/src/js/owl.navigation').then(()=>{
        jQuery('.js-single-articles-carousel').owlCarousel({
          nav: true,
          loop: true,
          dots: true,
          margin: 24,
          items: 1,
          slideBy: 1
        });

      
    });
  })
});